import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'amigo-theme';
  private _isDark = new BehaviorSubject<boolean>(false);

  isDark$ = this._isDark.asObservable();

  constructor() {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    const prefersDark = typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;
    this.apply(saved ? saved === 'dark' : prefersDark);
  }

  toggle(): void {
    this.apply(!this._isDark.value);
  }

  get isDark(): boolean {
    return this._isDark.value;
  }

  private apply(dark: boolean): void {
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light');
    localStorage.setItem(this.STORAGE_KEY, dark ? 'dark' : 'light');
    this._isDark.next(dark);
  }
}
